import {isFeatureEnabled} from '@github-ui/feature-flags'

import {
  useCollapsibleSidebarState as usePortableSidebarState,
  type UseCollapsibleSidebarStateOptions,
} from '@github-ui/layout-primitives-core'

export {
  GLOBAL_SIDEBAR_STORAGE_KEY,
  SIDEBAR_STATE_COOKIE_KEY,
  type SidebarState,
  type UseCollapsibleSidebarStateOptions,
  type CollapsibleSidebarState,
} from '@github-ui/layout-primitives-core'

export function useCollapsibleSidebarState(options: UseCollapsibleSidebarStateOptions = {}) {
  return usePortableSidebarState(options, isFeatureEnabled('primer_sidebar_shared_cookie'))
}
